import { COURSES_SECTION_INPUTS } from "./CoursesSection";
import { GENERAL_SECTION_INPUTS } from "./GeneralDataSection";
import { INITIAL_TRAIL_SECTION_INPUTS } from "./InitialTrailSection";
import { MANAGER_SECTION_INPUTS } from "./ManagerSection";
import { THEME_SECTION_INPUTS } from "./ThemeSection";
import { FEATURES_SECTION_INPUTS } from "./FeaturesSection";

export const validateForm = ({
  formValues = {},
  optionalKeys = [],
  isEditing = false,
}) => {
  const formKeys = [
    ...Object.values(GENERAL_SECTION_INPUTS),
    ...Object.values(INITIAL_TRAIL_SECTION_INPUTS),
    ...Object.values(MANAGER_SECTION_INPUTS),
    ...Object.values(THEME_SECTION_INPUTS),
    ...Object.values(COURSES_SECTION_INPUTS),
    ...Object.values(FEATURES_SECTION_INPUTS)
  ];

  const formErrors = formKeys.reduce((prev, key) => {
    if (optionalKeys.includes(key)) {
      return prev;
    }

    if(key === COURSES_SECTION_INPUTS.COURSES) {
      const restrictedCourses = formValues[GENERAL_SECTION_INPUTS.RESTRICTED_COURSES];
      const courseIDs = formValues[COURSES_SECTION_INPUTS.COURSES];

      if(restrictedCourses === "yes" && courseIDs?.length === 0) {
        return {
          ...prev,
          [key]: 'Você deve selecionar os cursos do painel'
        }
      }
    }

    if (key === GENERAL_SECTION_INPUTS.TOTAL_LICENSES) {
      const totalLicenses = +formValues[GENERAL_SECTION_INPUTS.TOTAL_LICENSES];

      if (Number.isNaN(totalLicenses) || totalLicenses <= 0) {
        return {
          ...prev,
          [key]: "A quantidade de licenças deve ser maior que 0",
        };
      }
    }

    if (
      [
        THEME_SECTION_INPUTS.COMPANY_LOGIN_IMAGE,
        THEME_SECTION_INPUTS.COMPANY_LOGO,
        THEME_SECTION_INPUTS.COMPANY_CERTIFICATE_LOGO,
      ].includes(key)
    ) {
      const image = formValues[key];

      if (!image?.url && !image?.imageFile) {
        return {
          ...prev,
          [key]: "Imagem não pode ficar vazia",
        };
      }
    }

    if (!isEditing && key === MANAGER_SECTION_INPUTS.NEW_MANAGER_EMAIL) {
      const emailValidation = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

      if (!emailValidation.test(formValues[key])) {
        return {
          ...prev,
          [key]: "Formato inválido de email",
        };
      }
    }

    if (!formValues[key]) {
      return {
        ...prev,
        [key]: "Campo não pode ficar vazio",
      };
    }

    return prev;
  }, {});

  return {
    hasError: Object.keys(formErrors).length > 0,
    errors: formErrors,
  };
};

export const createFormData = ({ formValues = {}, isEditing = false }) => {
  const formData = new FormData();

  formData.append("name", formValues[GENERAL_SECTION_INPUTS.COMPANY_NAME]);
  formData.append("description", formValues[GENERAL_SECTION_INPUTS.DESCRIPTION] || '');
  formData.append("status", formValues[GENERAL_SECTION_INPUTS.STATUS]);
  formData.append(
    "total_licenses",
    formValues[GENERAL_SECTION_INPUTS.TOTAL_LICENSES]
  );
  formData.append("url", formValues[GENERAL_SECTION_INPUTS.URL]);

  if(!isEditing) {
    formData.append(
      "manager",
      JSON.stringify({
        name: formValues[MANAGER_SECTION_INPUTS.NEW_MANAGER_NAME],
        email: formValues[MANAGER_SECTION_INPUTS.NEW_MANAGER_EMAIL],
      })
    );
  }

  if(isEditing) {
    
    if(formValues[MANAGER_SECTION_INPUTS.NEW_MANAGER_EMAIL]) {
      formData.append(
        "new_manager",
        JSON.stringify({
          name: formValues[MANAGER_SECTION_INPUTS.NEW_MANAGER_NAME],
          email: formValues[MANAGER_SECTION_INPUTS.NEW_MANAGER_EMAIL],
        })
      );
    }

    formData.append(
      "manager_emails_to_remove",
      JSON.stringify(formValues[MANAGER_SECTION_INPUTS.MANAGERS_EMAILS_TO_REMOVE])
    );
  }

  if(!isEditing) {
    formData.append(
      "trail",
      JSON.stringify({
        name: formValues[INITIAL_TRAIL_SECTION_INPUTS.TRAIL_NAME],
        description: formValues[INITIAL_TRAIL_SECTION_INPUTS.TRAIL_DESCRIPTION],
        courseIDs: formValues[INITIAL_TRAIL_SECTION_INPUTS.TRAIL_COURSE_IDS]
      })
    );
  }

  if(formValues[THEME_SECTION_INPUTS.COMPANY_LOGO]?.imageFile) {
    formData.append(
      "logo_image",
      formValues[THEME_SECTION_INPUTS.COMPANY_LOGO].imageFile
    );
  }

  if(formValues[THEME_SECTION_INPUTS.COMPANY_LOGIN_IMAGE]?.imageFile) {
    formData.append(
      "login_image",
      formValues[THEME_SECTION_INPUTS.COMPANY_LOGIN_IMAGE].imageFile
    );
  }

  if(formValues[THEME_SECTION_INPUTS.COMPANY_CERTIFICATE_LOGO]?.imageFile) {
    formData.append(
      "certificate_logo",
      formValues[THEME_SECTION_INPUTS.COMPANY_CERTIFICATE_LOGO].imageFile
    );
  }

  formData.append('restricted_courses', formValues[GENERAL_SECTION_INPUTS.RESTRICTED_COURSES]);
  formData.append('course_ids', formValues[COURSES_SECTION_INPUTS.COURSES]?.map(course => course.id)?.join(','));

  formData.append('color_primary', formValues[THEME_SECTION_INPUTS.COMPANY_COLORS][0]?.value);
  formData.append('color_secondary', formValues[THEME_SECTION_INPUTS.COMPANY_COLORS][1]?.value);
  formData.append('access_period', `${formValues[GENERAL_SECTION_INPUTS.ACCESS_PERIOD]}T20:59:59`);

  formData.append(
    'blocked_features', 
    JSON.stringify(formValues[FEATURES_SECTION_INPUTS.BLOCKED_FEATURES] || [])
  );

  return formData;
};